import React, { useState, useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import logo from './images/05-BTelco-Master-Fullcolour-logo.png';

// Answers are stored by the BT-PostCallSurvey-Submit API; the browser holds no AWS credentials.
const SUBMIT_URL = 'https://e47b0rrre3.execute-api.ap-southeast-2.amazonaws.com/submit';

function App() {
  const [callerID, setCallerID] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [feedback, setFeedback] = useState({
    rating: '',
    reasonForLowRating: [],
    reasonForHighRating: [],
    additionalFeedback: '',
    name: '',
    phone: '',
  });

  const location = useLocation();

  // Extract callerID from URL
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const callerIDFromURL = params.get('callerID');
    if (callerIDFromURL) setCallerID(callerIDFromURL);
  }, [location]);

  // Handle input changes
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFeedback((prev) => ({ ...prev, [name]: value }));
  };

  const handleCheckboxChange = (event, questionType) => {
    const { value, checked } = event.target;
    setFeedback((prevFeedback) => {
      const updated = { ...prevFeedback };
      const reasonKey = questionType === 'low' ? 'reasonForLowRating' : 'reasonForHighRating';
      updated[reasonKey] = checked
        ? [...updated[reasonKey], value]
        : updated[reasonKey].filter((item) => item !== value);
      return updated;
    });
  };

  // Handle form submit
  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!callerID) {
      alert('CallerID missing. Cannot submit feedback.');
      return;
    }

    setSubmitting(true);
    try {
      const resp = await fetch(SUBMIT_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          callerID,
          rating: feedback.rating,
          reasonForLowRating: feedback.reasonForLowRating,
          reasonForHighRating: feedback.reasonForHighRating,
          additionalFeedback: feedback.additionalFeedback,
          name: feedback.name,
          phone: feedback.phone,
        }),
      });
      const data = await resp.json().catch(() => ({}));

      if (resp.ok) {
        setSubmitted(true);
      } else {
        alert(data.message || 'Error submitting feedback. Please try again later.');
      }
    } catch (err) {
      console.error('Failed to submit feedback:', err);
      alert('Error submitting feedback. Please try again later.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="App">
      <img src={logo} alt="Logo" className="logo" />
      <h1>Welcome to The Bendigo Telco Post-Call Survey</h1>

      <Routes>
        <Route
          path="/webform"
          element={
            <div className="form-container">
              <h2>Feedback Form</h2>
              {submitted ? (
                <p>Thank you for your feedback!</p>
              ) : (
                <form onSubmit={handleSubmit}>
                  {/* Rating */}
                  <div className="form-section">
                    <label>How would you rate the support you received from our agent today? (Required)</label>
                    <div>
                      {[...Array(5)].map((_, i) => (
                        <label key={i}>
                          <input type="radio" name="rating" value={i + 1} onChange={handleInputChange} required />
                          {i + 1} - {['Poor','Fair','Good','Very Good','Excellent'][i]}
                        </label>
                      ))}
                    </div>
                  </div>

                  {/* Reasons */}
                  {feedback.rating && (
                    <div className="form-section">
                      <label>Can you provide the reason(s) for your score? (Required)</label>
                      <div>
                        {(feedback.rating < 3
                          ? ['My enquiry was not resolved','It took too long for my call to be answered','I received poor customer service','It took too long for my enquiry to be resolved','My expectations were not met','I’m not clear on the next steps','The contact lacked personalisation','Other']
                          : ['My enquiry was resolved quickly','The agent was friendly','My call was answered quickly','My expectations were met or exceeded','I was provided clear instructions','Other']
                        ).map((option, i) => (
                          <label key={i}>
                            <input
                              type="checkbox"
                              value={option}
                              onChange={(e) => handleCheckboxChange(e, feedback.rating < 3 ? 'low' : 'high')}
                            />
                            {option}
                          </label>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* Optional Fields */}
                  <div className="form-section">
                    <label>Additional Feedback (Optional)</label>
                    <textarea name="additionalFeedback" value={feedback.additionalFeedback} onChange={handleInputChange}></textarea>
                  </div>
                  <div className="form-section">
                    <label>Your Name (Optional)</label>
                    <input type="text" name="name" value={feedback.name} onChange={handleInputChange} />
                  </div>
                  <div className="form-section">
                    <label>Your Phone Number (Optional)</label>
                    <input type="text" name="phone" value={feedback.phone} onChange={handleInputChange} />
                  </div>

                  <button type="submit" disabled={submitting}>{submitting ? 'Submitting...' : 'Submit'}</button>
                </form>
              )}
            </div>
          }
        />
      </Routes>
    </div>
  );
}

export default App;
